import { render, staticRenderFns } from "./CustomerCustomerOffer.vue?vue&type=template&id=ff76165c&scoped=true"
import script from "./CustomerCustomerOffer.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerOffer.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerOffer.vue?vue&type=style&index=0&id=ff76165c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff76165c",
  null
  
)

export default component.exports